<ng-container *ngIf="!beneficioStatus">
  <div class="onboarding-beneficios__container">
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
  </div>
</ng-container>
<ng-container *ngIf="beneficioStatus">
  <div class="onboarding-beneficios__container">
    <app-onboarding-card
      imageUrl="../../../../../assets/images/heart.png"
      [title]="'1.1 - ' + ('provedores' | label)"
      redirectTo="/provedores"
      [checked]="beneficioStatus.provedor"
      [disabled]="false"
    ></app-onboarding-card>

    <app-onboarding-card
      imageUrl="../../../../../assets/images/report.png"
      title="1.2 - Benefícios"
      redirectTo="/provedores"
      [checked]="beneficioStatus.produto"
      [disabled]="!beneficioStatus.provedor"
    ></app-onboarding-card>

    <app-onboarding-card
      imageUrl="../../../../../assets/images/table.png"
      title="1.3 - Tabelas de preços"
      redirectTo="/provedores"
      [checked]="beneficioStatus.faixaDePreco"
      [disabled]="!beneficioStatus.produto"
    ></app-onboarding-card>
  </div>

  <form class="d-flex justify-content-end" (ngSubmit)="onNext()">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="!beneficioStatus.faixaDePreco"
    >
      Próximo
    </button>
  </form>
</ng-container>
